import { Component, Output, EventEmitter, Input } from '@angular/core';
import { UserModel } from '../../../models/user.model';

@Component({
  selector: 'app-ddl-user-control',
  templateUrl: './ddl-user-control.component.html',
  styleUrls: ['./ddl-user-control.component.scss']
})

/** dropdown-user component*/
export class DdlUserControlComponent {
  propertyValue;
  isDisableValue: boolean;
  @Input() title: string;
  @Input() users: Array<UserModel>;
  @Input('')
  get isDisabled() {
    return this.isDisableValue;
  }
  set isDisabled(value: boolean) {
    this.isDisableValue = value;
  }

  @Input() get property() {
    return this.propertyValue;
  }

  @Output() propertyChange = new EventEmitter();

  set property(val) {
    this.propertyValue = val;
    this.propertyChange.emit(this.propertyValue);
  }

  change() {
    this.property = !this.propertyValue;
  }
}
